// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const TeamviewerIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <g fill="currentColor" clipPath="url(#teamviewer_svga)">
      <path d="M18.94 2h-14A2.94 2.94 0 0 0 2 4.94v14a2.94 2.94 0 0 0 2.94 2.94h14a2.94 2.94 0 0 0 2.94-2.94v-14A2.94 2.94 0 0 0 18.94 2m-7 17.93a8 8 0 1 1 0-15.99 8 8 0 0 1 0 16" />
      <path d="m18.7 11.94-5.15-2.82.57 1.78H9.76l.57-1.78-5.16 2.82 5.16 2.82-.57-1.78h4.36l-.57 1.78z" />
    </g>
    <defs>
      <clipPath id="teamviewer_svga">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>,
  "Teamviewer",
);
export default TeamviewerIcon;
